import React, { useEffect, useState } from "react";
import { Button, Card, Empty, Popconfirm, Space, Table, Tag } from "antd";
import axios from "axios";
import { message } from "@bindeleddet/core/utils";
import { Job } from "@bindeleddet/core/types";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import dayjs from "dayjs";

interface Props {
  companyId: number;
}

const AllCompanyJobs: React.FC<Props> = ({ companyId }) => {
  const [jobPostings, setJobPostings] = useState<Job[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const history = useHistory();

  useEffect(() => {
    axios
      .get<Job[]>(`/jobs/${companyId}/job-list/`)
      .then(response => {
        setJobPostings(response.data.sort((a, b) => dayjs(b.deadline).diff(dayjs(a.deadline))));
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [companyId]);

  const columns = [
    {
      title: "Tittel",
      dataIndex: "title",
      width: "55%",
      ellipsis: true,
    },
    {
      title: "Søknadsfrist",
      dataIndex: "deadline",
      width: "15%",
      render: (deadline: string) => {
        return <Tag color={dayjs(deadline) < dayjs() ? "red" : "green"}>{dayjs(deadline).format("DD.MM.YYYY")}</Tag>;
      },
      ellipsis: true,
    },
    {
      title: "Visninger",
      dataIndex: "views",
      width: "12.5%",
      ellipsis: true,
    },
    {
      title: "",
      dataIndex: "",
      width: "12.5%",
      align: "right" as const,
      ellipsis: true,
      render: (job: Job) => (
        <Space>
          <Button
            type="text"
            shape="circle"
            icon={<EditOutlined />}
            onClick={() => history.push(`/admin/companies/${companyId}/edit-job/${job.id}/`)}
          />
          <Popconfirm
            title={`Er du sikker på at du vil slette stillingsannonsen "${job.title}"?`}
            okText="Slett"
            cancelText="Avbryt"
            okType="danger"
            onConfirm={() => {
              axios
                .delete<Job>(`/jobs/${companyId}/job-list/${job.id}/`)
                .then(() => {
                  message("success", "Stillingsannonsen er slettet");
                  setJobPostings(jobPostings.filter(j => j.id !== job.id));
                })
                .catch(() => message("error", "Kunne ikke slette stillingsannonsen. Prøv igjen senere"));
            }}
          >
            <Button
              type="text"
              shape="circle"
              danger
              icon={<DeleteOutlined />}
              onClick={event => event.stopPropagation()}
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Card
        title="Stillingsannonser"
        extra={
          <Button type="primary" onClick={() => history.push(`/admin/companies/${companyId}/create-new-job/`)}>
            Ny stillingsannonse
          </Button>
        }
      >
        <Table
          columns={columns}
          dataSource={jobPostings}
          size="small"
          rowKey="id"
          onRow={(_record, rowKey) => ({
            onClick: () => {
              if (rowKey === undefined) return null;
              /* history.push(`/admin/jobs/${jobPostings[rowKey].id}`); */
            },
          })}
          locale={{
            emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Ingen stillingsannonser" />,
          }}
          loading={loading}
          pagination={{ pageSize: 5 }}
        />
      </Card>
    </>
  );
};

export default AllCompanyJobs;
